import { ClosedLostReason } from "@shared/constants";

export const getTenantReferralIdDisplay = (tenantReferralId: number | null) =>
  tenantReferralId ? `#${tenantReferralId}` : "-";

export const getTranslationKeyForClosedLostCategory = (
  closedLostReason: ClosedLostReason | undefined
) => (closedLostReason ? `table.closedLostReasons.${closedLostReason}` : "-");
